<template>
  <div class="integral-manager">
    <Tabs v-model="intType">
      <TabPane label="积分管理" name="rule">
        <p class="notice">
          <Icon type="md-alert" />设置积分时间后，学员在学员端获得积分，可在积分商城兑换相应的商品，禁用后，仅对后续的数据有影响，对旧数据无影响
        </p>
        <div class="content">
          <Grid
            ref="grid"
            :columns="columns"
            data-url="/api/integral/rule"
            :rowsFormatter="rowsFormatter"
            selectType="none"
            keyField="key"
            method="get"
          >
            <template slot-scope="{ row }" slot="c1">
              <template v-if="row.key=='buy_success'">
                <span>{{row.name}}</span>
                <Tooltip content="学员支付成功后，在7天后方可获得积分，如7天内学员主动发起退款，将不给与其积分" placement="bottom">
                  <i class="ivu-icon ivu-icon-md-help-circle"></i>
                </Tooltip>
              </template>
              <template v-else>{{row.name}}</template>
            </template>
            <template slot-scope="{ row }" slot="action">
              <Button
                type="text"
                size="small"
                @click="updataState(row)"
              >{{row.status == 1 ? "禁用":"启用"}}-</Button>
              <Button type="text" size="small" @click="editInter(row)">编辑</Button>
            </template>
          </Grid>
        </div>
      </TabPane>
      <TabPane label="积分设置" name="set">
        <div class="title">基本信息</div>
        <Form ref="intset" v-model="baseInfo" :label-width="100">
          <FormItem label="积分名称：">
            <Input
              style="width:300px"
              type="text"
              v-model="baseInfo.point_name"
              placeholder="请输入积分名称"
              clearable
            />
          </FormItem>
          <FormItem label="积分有效期：">
            <RadioGroup v-model="baseInfo.point_validity">
              <Radio label="2">不限</Radio>
              <Radio label="1">1年</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="积分规则：">
            <UEditor v-model="baseInfo.point_rule_info"></UEditor>
          </FormItem>
          <div style="text-align: center;">
            <Button style="width: 120px" size="large" type="primary" @click="submits">保存</Button>
          </div>
        </Form>
      </TabPane>
    </Tabs>
    <Modal v-model="isShow" title="编辑规则">
      <Form ref="form" v-model="currentRow" :label-width="100">
        <FormItem label="事件：">
          <span>{{currentRow.name}}</span>
        </FormItem>
        <FormItem label="周期：">
          <span v-if="currentRow.key=='register' || currentRow.key=='perfect_information'">一次</span>
          <Select v-else v-model="currentRow.period_type" style="width:200px" clearable>
            <Option value="1">一次</Option>
            <Option value="2">每天</Option>
            <Option value="3">不限</Option>
          </Select>
        </FormItem>
        <FormItem v-show="currentRow.period_type==2" label="周期内最大奖励次数：">
          <InputNumber
            v-model="currentRow.every_day_times"
            :min="1"
            :max="10000"
            :precision="0"
            placeholder="请输入"
          />次
        </FormItem>
        <FormItem label="奖励积分：">
          <InputNumber
            v-model="currentRow.integral"
            :min="1"
            :max="10000"
            :precision="0"
            placeholder="请输入"
          />分
        </FormItem>
        <FormItem v-if="currentRow.key == 'share' || currentRow.key == 'collect'" label="奖励限制：">
          <Checkbox
            v-model="currentRow.is_unique_boolean"
          >同一个内容反复{{currentRow.key == 'share' ? '分享':'收藏'}}仅奖励一次</Checkbox>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="isShow=false">取消</Button>
        <Button type="primary" size="large" @click="onOk">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import UEditor from "@/components/UEditor.vue";
export default {
  name: "IntegralManage",
  components: {
    UEditor
  },
  data() {
    return {
      intType: "rule",
      columns: [
        {
          title: "事件",
          slot: "c1",
          align: "center"
        },
        {
          title: "奖励次数",
          key: "period_type_name",
          align: "center",
          renderHeader: h => {
            return h("div", [
              h("span", "奖励次数"),
              h(
                "Tooltip",
                {
                  props: {
                    content: `一次：该周期内，学员进行的相应积分行为仅支持奖励一次；积分不限：该周期内，学员进行的相应积分行为获取的奖励次数不限；每天X次：该周期内，学员每天进行的积分行为可获得X次奖励`
                  }
                },
                [
                  h("i", {
                    attrs: { class: "ivu-icon ivu-icon-md-help-circle" }
                  })
                ]
              )
            ]);
          }
        },
        {
          title: "奖励积分",
          key: "integral",
          align: "center"
        },
        {
          title: "启用状态",
          key: "status_name",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          fixed: "right"
        }
      ],
      currentRow: [],
      baseInfo: {},
      isShow: false
    };
  },
  methods: {
    rowsFormatter(row) {
      row.forEach(item => {
        item.period_type_name =
          item.period_type == 1
            ? "一次"
            : item.period_type == 2
            ? "每天"
            : "不限";
        item.status_name = item.status == 1 ? "已启用" : "已禁用";
      });
    },
    async getBaseInfo() {
      this.baseInfo = await this.$http.get(`/api/integral/info`);
    },
    async updataInter(params) {
      await this.$http.put(`/api/integral/rule`, params);
      this.$refs.grid.refresh();
    },
    updataState(row) {
      let params = {
        key: row.key,
        status: row.status == 1 ? 2 : 1
      };
      this.updataInter(params);
    },
    editInter(row) {
      row.integral = Number(row.integral);
      row.is_unique_boolean = row.is_unique == 1 ? true : false;
      this.currentRow = row;
      this.isShow = true;
    },
    async onOk() {
      if (this.currentRow.is_unique_boolean) {
        this.currentRow.is_unique = 1;
      } else {
        this.currentRow.is_unique = 2;
      }
      await this.updataInter(this.currentRow);
      this.isShow = false;
    },
    async submits() {
      await this.$http.put(`/api/integral/info`, this.baseInfo);
      this.$Message.success("保存成功");
      this.getBaseInfo();
    }
  },
  created() {
    this.getBaseInfo();
  }
};
</script>
<style lang="scss" scoped>
.integral-manager {
  .notice {
    font-size: 14px;
    line-height: 30px;
    vertical-align: middle;
  }
  /deep/ .ivu-table-cell {
    > div {
      span {
        vertical-align: middle;
      }
      .ivu-tooltip-inner {
        white-space: normal;
      }
    }
  }
}
.content {
  /deep/ {
    .ivu-table-wrapper {
      overflow: visible;
    }
  }
}
</style>